import { DEFAULT_COUNTRY_CODE } from "app/modules/project-from-comparison/config";
import { useProjectCreation } from "app/modules/project-from-comparison/context";
import { isSameProjectExist } from "app/modules/project-from-comparison/helpers/isSameProjectExist";
import { isWebsiteAnalysisPage } from "app/modules/project-from-comparison/helpers/isWebsiteAnalysisPage";
import { useExistingProjects } from "app/modules/project-from-comparison/helpers/useExistingProjects";
import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const useAccessForButton = () => {
    const { country = DEFAULT_COUNTRY_CODE } = proNavigator.getParams();
    const { domains } = useProjectCreation();
    const { existingProjects } = useExistingProjects();
    const isProjectAllowed = ActivationComponentAssets.isAllowed;
    const hasFreeLimit = ActivationComponentAssets.projectsLimit > existingProjects.length;
    const isExist = isSameProjectExist(existingProjects, domains, country);
    const isWAPage = isWebsiteAnalysisPage();
    const hasCompetitors = domains.length > 1;
    const hasAtLeast1domain = domains.length >= 1;

    return {
        isExist,
        hasFreeLimit,
        isWAPage,
        isProjectAllowed,
        hasCompetitors,
        hasAtLeast1domain,
    };
};
